var _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRectangleRoundCornersMg = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.33 50.9H31.77a2.761 2.761 0 0 1-2.87-2.65V31.67a2.691 2.691 0 0 1 2.8-2.57h32.48A2.699 2.699 0 0 1 67 31.65v16.58c.03 1.44-1.1 2.63-2.54 2.66h-.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.65 51.86A3.727 3.727 0 0 1 28 48.27v-16.6c.09-2 1.76-3.56 3.76-3.53h32.42A3.675 3.675 0 0 1 68 31.62v16.61a3.575 3.575 0 0 1-3.5 3.62H31.65Zm0-21.8c-.93 0-1.7.73-1.75 1.66v16.52c.04.99.85 1.77 1.84 1.77H64.4c.92-.03 1.63-.8 1.6-1.72V31.67c-.07-.94-.88-1.66-1.82-1.62H31.65Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.44,
    height: 19.38,
    x: 77.95,
    y: 49.99,
    fill: "#fff",
    rx: 0.95,
    ry: 0.95,
    transform: "rotate(-54.71 80.17 59.682)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.57 67.68c-.4 0-.79-.13-1.12-.36L71.16 57.23a1.89 1.89 0 0 1-.46-2.63v-.02h.01l1.45-2.07c.61-.86 1.8-1.07 2.66-.46l14.29 10.1c.86.61 1.07 1.8.46 2.66l-1.46 2.07c-.36.5-.93.8-1.54.8Zm-12.8-14.07-1.46 2.07L86.6 65.77l1.47-2.06-14.3-10.1Zm14.3 10.09.77.56-.77-.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m75.478 58.648 2.575-3.641 1.56 1.103-2.576 3.641z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.27,
    cy: 48.43,
    r: 11.6,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.25 61c-6.94 0-12.56-5.63-12.55-12.57 0-6.94 5.63-12.56 12.57-12.55 2.6 0 5.13.81 7.25 2.31 5.66 4.01 7 11.85 2.99 17.51-2.36 3.33-6.18 5.3-10.26 5.3Zm0-23.21c-5.89.03-10.64 4.82-10.61 10.71s4.82 10.64 10.71 10.61c5.89-.03 10.64-4.82 10.61-10.71-.02-3.47-1.72-6.72-4.57-8.7-1.8-1.25-3.95-1.92-6.14-1.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.48 55.84h-4.86l-1.51-4h6.37c4.42 0 8-3.58 8-8V37.4l4 1.49v5c0 6.63-5.37 12-12 12v-.05Z"
  })));
};
export default SvgRectangleRoundCornersMg;